import {ref} from "vue";
import {useMutation, useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast, successToast} from "@/composables/useToasts";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";


const showModal = ref(false);
const showLoadingModal = ref(false);

const reset = () => {
  showModal.value = false;
  showLoadingModal.value = false;
};

const getToneOfVoice = () => useQuery({
  queryKey: ['tone-of-voice'],
  queryFn: async () => {
    const { data } = await axios.get(`/ajax/v2/seo-agent-settings/tone-of-voice`);

    return data.data;
  }
});

const reviseToneOfVoice = () => {
  const {revisionErrors} = useApprovalFlow();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      showLoadingModal.value = true;
      revisionErrors.value = undefined;

      const {feedback, individualFeedbacks = null} = data;

      await axios.post('/ajax/v2/seo-agent-settings/revise-tone-of-voice', {
        feedback,
        individual_feedbacks: individualFeedbacks,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['tone-of-voice']});

      successToast("Tone of Voice revised successfully.");
    },
    onError: (error) => {
      let errorMessage = error.response?.data?.message || 'Something went wrong revising your Tone of Voice';

      if (error.response?.data?.errors) {
        revisionErrors.value = error.response?.data?.errors;
      }

      errorToast(errorMessage);
    },
  });
};

export {
  showModal,
  showLoadingModal,
  reset,
  getToneOfVoice,
  reviseToneOfVoice,
};
